import React from 'react';
import { Flex, Row } from 'antd';
import { FormOutlined, AppstoreAddOutlined } from '@ant-design/icons';
import NavItem from '../../components/nav-item';
import List from './list';

const iconStyle = {
    fontSize: 28,
}

export default () => {
  return (
    <div>
        create
    </div>
  )
}